<template>
  <div class="col-sm-12 col-md-8 mb-2">
    <div class="vendor-tile shadow-sm shadow-hover">
      <a :href="link">
        <div class="p-2 d-flex">
          <div v-if="image" class="flex-shrink-0">
            <Avatar :src="image" :alt="name" />
          </div>
          <div class="bg-white flex-grow-1">
            <div class="px-2">
              <div class="h5 mb-0 text-break">
                {{ name | truncate(60) }}
              </div>
              <div v-if="categories" class="mb-0 text-break text-xs text-muted">
                {{ categories }}
              </div>
              <div v-if="badges.length" class="mt-2">
                <BadgeGroup>
                  <Badge
                    v-for="(badge, index) in badges"
                    :key="index"
                    :text="badge.text"
                    :variant="badge.variant"
                  ></Badge>
                </BadgeGroup>
              </div>
              <div v-if="product_link" class="mt-2">
                <ActionButton variant="small" :href="product_link">
                  {{ action_button_text }}
                </ActionButton>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import ActionButton from "../buttons/ActionButton.vue";
import Avatar from "../avatar/Avatar.vue";
import Badge from "../badges/Badge.vue";
import BadgeGroup from "../badges/BadgeGroup.vue";

export default {
  name: "VendorTile",
  components: {
    ActionButton,
    Avatar,
    Badge,
    BadgeGroup,
  },
  props: {
    action_button_text: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      required: true,
    },
    product_link: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.vendor-tile {
  border: $width-border-thin solid $gray-200;
  border-radius: $border-radius;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  background: $white;
  height: 100%;
}
</style>
